import React from 'react';
import programs from 'assets/images/day-of/socialProofPrograms.png';
import placeCards from 'assets/images/day-of/socialProofPlaceCards.png';
import menus from 'assets/images/day-of/socialProofMenus.png';

import {
  SocialProofContainer,
  SocialProofSection,
  SocialProofSectionContainer,
  SectionHeading,
  SectionTitle,
  SectionSubTitle,
  SocialProofCard,
  SocialProofCardImg,
  SocialProofCardLabel,
  StyledScrollCarousel,
  StyledLinkV2,
} from './SocialProof.style';

const SOCIAL_PROOF_CARDS = [
  {
    img: programs,
    label: 'Kianna',
    link: '/wedding-planning/programs/90232b69-fd48-474a-958a-ebb279a48686',
  },
  {
    img: placeCards,
    label: 'Bayway',
    link: '/wedding-planning/place-cards/3b574df9-57aa-4e3a-a2ca-fe1c809d05e5',
  },
  {
    img: menus,
    label: 'Goundry',
    link: '/wedding-planning/menus/84a5c792-800e-41fc-ac92-c5dc9e063ccf',
  },
];

export const SocialProof: React.FC = () => (
  <SocialProofContainer>
    <SocialProofSectionContainer>
      <SocialProofSection>
        <SectionHeading>
          <SectionTitle>
            Designs <span>IRL</span>
          </SectionTitle>
          <SectionSubTitle>Favorites from our very own Zola team</SectionSubTitle>
        </SectionHeading>
        <StyledScrollCarousel>
          {SOCIAL_PROOF_CARDS.map((card, index) => (
            <SocialProofCard key={index}>
              <StyledLinkV2 href={card.link} noUnderline>
                <SocialProofCardImg src={card.img} alt={card.label} />
                <SocialProofCardLabel>{card.label}</SocialProofCardLabel>
              </StyledLinkV2>
            </SocialProofCard>
          ))}
        </StyledScrollCarousel>
      </SocialProofSection>
    </SocialProofSectionContainer>
  </SocialProofContainer>
);
